/**
 * Once WebRTC media failed in this tab, new live views start on HLS for a
 * while instead of waiting for WebRTC to fail again on every tile (a phone on
 * a network the media server's WebRTC port does not reach would otherwise
 * wait ~15 s per camera).
 */
const WEBRTC_RETRY_AFTER_MS = 10 * 60_000;
let webrtcFailedAt = 0;

export const webrtcRecentlyFailed = () => Date.now() - webrtcFailedAt < WEBRTC_RETRY_AFTER_MS;

/** Records that the WebRTC media path failed (the network, not a camera). */
export function rememberWebRTCFailure() {
  webrtcFailedAt = Date.now();
}

/** Tries WebRTC first again (a retry asked for by the viewer; tests). */
export function forgetWebRTCFailure() {
  webrtcFailedAt = 0;
}
